import moment from "moment";

/**
 * Injects placeholder passport / nationality fields required by the book API
 * for domestic itineraries where passport UI is hidden.
 *
 * @param {object} passenger - Mutated in place
 * @param {Date} [referenceDate] - Anchor for expiry (defaults to now); injectable in tests
 * @returns {object} The same passenger reference
 */
export function applyDomesticPassportPlaceholders(
  passenger,
  referenceDate = new Date()
) {
  const passportExpiryDate = moment(referenceDate).add(5, "years");

  passenger.nationality = "ZA";
  passenger.passportNumber = "11111111";
  passenger.passportCountry = "ZA";
  passenger.tempPassportExpiry = passportExpiryDate.toDate();
  passenger.passportExpiry = {
    day: Number(passportExpiryDate.format("DD")),
    month: Number(passportExpiryDate.format("MM")),
    year: Number(passportExpiryDate.format("YYYY"))
  };

  return passenger;
}
